import { httpApi } from '@fd/common/api/basicHttpApi';
import { PoolType } from '@fd/common/biz/PoolType';
import useSWR from 'swr';
import useAccount from './useAccount';

export default function usePools() {
  const account = useAccount();
  const response = useSWR(account ? '/pools/list' : undefined, fetchPools);
  return response;
}

async function fetchPools(): Promise<PoolType[]> {
  const result = await httpApi('/pools/list', undefined, 'GET');
  const pools = result as PoolType[];
  return pools.sort((a, b) => b.id - a.id);
}
